import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import styles from "./NewEvent.module.css";
import TimePicker from "./TimePicker";
import { useState } from "react";
import BanquetRoomPicker from "./BanquetRoomPicker";
import ServiceType from "./ServiceType";
import Button from "./Button";
import { useSiteInfo } from "../context/SiteContext";
import { validateForm } from "../helpers/helperFunctions";
import React from "react";

function NewEvent() {
  const [searchParams] = useSearchParams();
  const theDate = new Date(searchParams.get("d"));
  const rest = searchParams.get("r");
  const navigate = useNavigate();
  const locations = JSON.parse(sessionStorage.getItem("locations"));
  const userData = JSON.parse(localStorage.getItem("userLogin"));

  const [hasNameTyped, setHasNameTyped] = useState(false);
  const [customerMatch, setCustomerMatch] = useState([]);

  const location = locations.filter((loc) => loc.idLocation == Number(rest));
  const closeModal = () => {
    navigate("/");
  };
  const handleCreate = (d, r) => {
    navigate(`/event/1`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (customerMatch.length > 0) {
      e.setCustomValidity("Not Valid");
    }

    if (validateForm(e.target)) {
      const formData = new FormData(e.target);
      formData.append("bandate", theDate.toISOString().substring(0, 10));
      formData.append("locationid", rest);
      formData.append("user", userData.user);
      formData.append("userId", userData.userId);

      console.log(formData);

      const resRooms = fetch("/api/event", {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(formData),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.newid) {
            navigate(`/event/${data.newid}`);
          }
        });
    }
  };

  const handleTextChanged = () => {
    let fname = document.getElementById("firstname").value;
    let lname = document.getElementById("lastname").value;
    let ph = document.getElementById("telephone").value;
    let em = document.getElementById("email").value;
    let comp = document.getElementById("companyname").value;

    if (fname != "" || lname != "" || ph != "" || em != "") {
      const resRooms = fetch(`/api/customers?f=${fname}&l=${lname}&t=${ph}&e=${em}&c=${comp}`, {
        method: "get",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setHasNameTyped(true);
          } else {
            setHasNameTyped(false);
          }
          setCustomerMatch(data);
        });
    } else {
      setHasNameTyped(false);
    }
  };

  const updatePhoneNumber = (e) => {
    let tele = e.target.value;
    tele = tele.replace(/[^0-9]/g, "");
    let returnVal = tele;
    if (tele.length > 3 && tele.length <= 6) {
      returnVal = tele.slice(0, 3) + "-" + tele.slice(3);
    } else if (tele.length > 6 && tele.length < 11) {
      returnVal = tele.slice(0, 3) + "-" + tele.slice(3, 6) + "-" + tele.slice(6, 10);
    } else if (tele.length >= 10) {
      returnVal = tele.slice(0, 3) + "-" + tele.slice(3, 6) + "-" + tele.slice(6, 10);
    }
    e.target.value = returnVal;
    handleTextChanged();
  };

  const makeInvalid = (e) => {
    e.target.classList.add("invalid");
  };

  const clearText = () => {
    document.getElementById("firstname").value = "";
    document.getElementById("lastname").value = "";
    document.getElementById("telephone").value = "";
    document.getElementById("email").value = "";
    document.getElementById("customerid").value = "";
    setHasNameTyped(false);
    setCustomerMatch([]);
  };

  function handleRowClick(cId) {
    let co = customerMatch[cId];
    document.getElementById("firstname").value = co.FirstName;
    document.getElementById("lastname").value = co.LastName;
    document.getElementById("telephone").value = co.Phone;
    document.getElementById("email").value = co.Email;
    document.getElementById("customerid").value = co.idCustomers;
    setHasNameTyped(false);
    setCustomerMatch([]);
  }

  return (
    <>
      <div className={styles.newEventFrame}>
        <h2 className={styles.newEventHeader}>
          Create New Event on{" "}
          {theDate.toLocaleDateString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}{" "}
          in {location[0].Description}{" "}
        </h2>
        <section className={styles.container}>
          <h3>Event Detail</h3>
          <form className="form" onSubmit={handleSubmit} noValidate>
            <input type="hidden" name="customerid" id="customerid" />
            <input type="hidden" value="8" name="companyid" id="companyid" />
            <div className="formRow">
              <label>Event Name *</label>
              <input type="text" id="eventname" name="eventname" tabIndex={1} required onInvalid={makeInvalid} />
              <div className="invalid-feedback">Event name required</div>
            </div>
            <div className={styles.customerDetail}>
              <h4>
                Customer Information{" "}
                <span className={styles.clearButtonArea}>
                  <Button type="outline" onClick={clearText} isSubmit={false}>
                    Clear
                  </Button>
                </span>
              </h4>
              <div className="formRow formRow-flex">
                <div>
                  <label>First Name *</label>
                  <input type="text" id="firstname" name="firstname" tabIndex={2} required onInvalid={makeInvalid} onChange={handleTextChanged} />
                  <div className="invalid-feedback">Event name required</div>
                </div>
                <div>
                  <label>Last Name *</label>
                  <input type="text" id="lastname" name="lastname" tabIndex={2} required onInvalid={makeInvalid} onChange={handleTextChanged} />
                  <div className="invalid-feedback">Event name required</div>
                </div>
              </div>
              <div className="formRow">
                <label>Company Name</label>
                <input type="text" id="companyname" name="companyname" tabIndex={3} />
                {/* <div className="invalid-feedback">
                            Event name required
                        </div> */}
              </div>
              <div className="formRow">
                <label>Phone number *</label>
                <input
                  type="text"
                  id="telephone"
                  name="telephone"
                  tabIndex={4}
                  required
                  onInvalid={makeInvalid}
                  onKeyUp={(e) => updatePhoneNumber(e)}
                />
                <div className="invalid-feedback">Phone number required</div>
              </div>
              <div className="formRow">
                <label>E-Mail *</label>
                <input type="text" id="email" name="email" tabIndex={5} required onInvalid={makeInvalid} onChange={handleTextChanged} />
                <div className="invalid-feedback">Email required</div>
              </div>
            </div>
            <div className={styles.eventDetail}>
              <h4>Event Information</h4>
              <div className="formRow">
                <label>Guest Count *</label>
                <input type="number" id="guestcount" name="guestcount" tabIndex={6} required onInvalid={makeInvalid} />
                <div className="invalid-feedback">Guest count required</div>
              </div>
              <div className="formRow">
                <label>Arrival/Start time</label>
                <TimePicker theName="arrival" />
              </div>
              <div className="formRow">
                <label>Banquet Room</label>
                <BanquetRoomPicker location_id={Number(rest)} />
              </div>
              <div className="formRow">
                <label>Room Charge *</label>
                <input type="text" id="roomcharge" name="roomcharge" tabIndex={7} required onInvalid={makeInvalid} defaultValue={150.0} />
                <div className="invalid-feedback">Room charge required</div>
              </div>
              <div className="formRow">
                <label>Service Type</label>
                <ServiceType />
              </div>
            </div>
            <div className={styles.saveButtons}>
              <Button type="primary">Save</Button>
              <Button type="save" onClick={closeModal}>
                Cancel
              </Button>
            </div>
            <div className={`formRow ${styles.mt2}`}>
              <small>* required fields.</small>
            </div>
          </form>
        </section>
        <section className={styles.customerReview}>
          {hasNameTyped && (
            <div className={styles.customerMatch}>
              <h3>Potential Matching Customers</h3>
              <table>
                <thead>
                  <tr>
                    <th>Customer Name</th>
                    <th>Company Name</th>
                    <th>Phone</th>
                    <th>E-Mail</th>
                  </tr>
                </thead>
                <tbody>
                  {customerMatch.map((customer, index) => {
                    return (
                      <tr className={styles.selectRow} onClick={() => handleRowClick(index)}>
                        <td>
                          {customer.FirstName + " " + customer.LastName}
                          <input type="hidden" id="customermatchid" value={customer.idCustomers} />
                        </td>
                        <td>
                          {customer.CompanyName}
                          <input type="hidden" id="companymatchid" value={customer.idCompany} />
                        </td>
                        <td>{customer.Phone}</td>
                        <td>{customer.Email}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </div>
    </>
  );
}

export default NewEvent;
